import { ARKON } from '@/consts/systems.consts';

export const ANSWER_DELIVERY_OPTIONS = [
  { value: ARKON.CS.DELIVERY.METHODS.CODES.IN_PERSON, label: 'Δια ζώσης' },
  { value: ARKON.CS.DELIVERY.METHODS.CODES.EMAIL, label: 'Email' },
  { value: ARKON.CS.DELIVERY.METHODS.CODES.POST, label: 'Ταχυδρομικώς' },
  {
    value: ARKON.CS.DELIVERY.METHODS.CODES.AUTHORIZED_PERSON,
    label: 'Εξουσιοδοτημένο άτομο',
  },
];
